/* Gooseberry — Set builder (bra + panty / bikini top + bottom)
 * Two steps; choosing a piece moves you to the next step automatically.
 * Adds both pieces as separate cart lines with hidden _gb_bundle + _gb_bundle_type
 * properties; the "Gooseberry Bundle Discount" function applies the set discount. */
(function () {
  'use strict';

  /* ---------- pure helpers (exported for tests) ---------- */
  function formatMoney(cents, format) {
    format = format || '${{amount}}';
    var value = cents / 100;
    function delimit(num, decimals, thousands, decimal) {
      var parts = num.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return delimit(value, 0, ',', '.');
        case 'amount_with_comma_separator': return delimit(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delimit(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delimit(value, 2, "'", '.');
        default: return delimit(value, 2, ',', '.');
      }
    });
  }

  function summarise(picks, pct) {
    var n = picks.filter(Boolean).length;
    var sub = picks.reduce(function (a, p) { return a + (p ? p.price : 0); }, 0);
    var save = n === 2 ? picks.reduce(function (a, p) { return a + Math.round(p.price * pct / 100); }, 0) : 0;
    return { n: n, sub: sub, save: save, total: sub - save, complete: n === 2 };
  }

  function buildItems(picks, bundleId, type, label) {
    return picks.filter(Boolean).map(function (p) {
      return { id: Number(p.variantId), quantity: 1, properties: { _gb_bundle: bundleId, _gb_bundle_type: type, Bundle: label } };
    });
  }

  function newBundleId() {
    return 'GS-' + Date.now().toString(36).toUpperCase() + '-' + Math.random().toString(36).slice(2, 6).toUpperCase();
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { formatMoney: formatMoney, summarise: summarise, buildItems: buildItems, newBundleId: newBundleId };
    return;
  }


  /* Turns the product description HTML into a short intro + collapsible spec sections.
     Only text is read from the HTML (textContent), so no merchant markup or styles leak in. */
  function renderDescription(html, mount, cls) {
    mount.innerHTML = '';
    if (!html) return;
    var doc = new DOMParser().parseFromString('<div>' + html + '</div>', 'text/html');
    var wrap = doc.body.firstElementChild;
    var clean = function (t) { return String(t || '').replace(/\s+/g, ' ').trim(); };
    var isList = function (el) { return el && /^(UL|OL)$/.test(el.tagName); };
    function isHeading(el) {
      if (/^H[1-6]$/.test(el.tagName)) return true;
      if (el.tagName !== 'P') return false;
      var t = clean(el.textContent);
      if (!t || t.length > 40) return false;
      if (el.querySelector('u, strong, b, [style*="underline"]')) return true;
      var next = el.nextElementSibling;
      while (next && !clean(next.textContent) && !isList(next)) next = next.nextElementSibling;
      return isList(next);
    }
    var intro = [], sections = [], cur = null;
    Array.prototype.forEach.call(wrap.children, function (el) {
      if (isHeading(el)) { cur = { title: clean(el.textContent).replace(/[:\s]+$/, ''), items: [], text: [] }; sections.push(cur); return; }
      if (isList(el)) {
        var items = Array.prototype.map.call(el.querySelectorAll('li'), function (li) { return clean(li.textContent); }).filter(Boolean);
        if (cur) cur.items = cur.items.concat(items); else intro.push(items.join(' · '));
        return;
      }
      var t = clean(el.textContent);
      if (!t) return;
      if (cur) cur.text.push(t); else intro.push(t);
    });
    if (!sections.length && intro.length === 0) { intro.push(clean(wrap.textContent)); }
    intro.filter(Boolean).forEach(function (t) {
      var p = document.createElement('p'); p.className = cls + '__lede'; p.textContent = t; mount.appendChild(p);
    });
    sections.forEach(function (s, i) {
      if (!s.items.length && !s.text.length) return;
      var d = document.createElement('details'); d.className = cls + '__sec';
      var sum = document.createElement('summary'); sum.textContent = s.title;
      var ch = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      ch.setAttribute('width', '12'); ch.setAttribute('height', '12'); ch.setAttribute('viewBox', '0 0 24 24'); ch.setAttribute('aria-hidden', 'true');
      ch.innerHTML = '<path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="1.6"/>';
      sum.appendChild(ch); d.appendChild(sum);
      if (s.items.length) {
        var ul = document.createElement('ul');
        s.items.forEach(function (t) { var li = document.createElement('li'); li.textContent = t; ul.appendChild(li); });
        d.appendChild(ul);
      }
      s.text.forEach(function (t) { var p = document.createElement('p'); p.textContent = t; d.appendChild(p); });
      mount.appendChild(d);
    });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function storage() {
    try { var k = '__gbs'; sessionStorage.setItem(k, k); sessionStorage.removeItem(k); return sessionStorage; } catch (e) { return null; }
  }

  /* ---------- open the theme's cart drawer with fresh contents ----------
     The theme's "apps:product-added-to-cart" event only refreshes the cart, it doesn't open the drawer
     (Rebuy used to do that until its embed was switched off). So: tell the theme, reload the drawer's
     contents, then click the bag icon — the same way the collection quick add and the welcome-back
     popup open it. Same helper as gb-bundle-builder.js. */
  function openCartDrawer(cfg, items) {
    if (cfg.drawerEvent) {
      try { document.dispatchEvent(new CustomEvent(cfg.drawerEvent, { bubbles: true, detail: { items: items } })); } catch (e) {}
    }
    try { if (typeof window.updateCartCount === 'function') window.updateCartCount(); } catch (e) {}
    var isOpen = function () {
      return !!document.querySelector('.quick-cart__wrapper.active') || document.body.getAttribute('data-fluorescent-overlay-open') === 'true';
    };
    setTimeout(function () {
      try { if (typeof window.refreshCart === 'function') window.refreshCart(); } catch (e) {}
      setTimeout(function () {
        if (isOpen()) return;
        var icon = document.querySelector('a[data-js-cart-icon]') || document.querySelector('[data-js-cart-icon]');
        if (icon) icon.click(); else window.location.href = cfg.cartUrl || '/cart';
      }, 500);
    }, 200);
  }

  function init(root) {
    if (root.__gbs) return;
    root.__gbs = true;

    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-gbs-config]').textContent); } catch (e) {}
    var pct = (cfg.pct === 0) ? 0 : (Number(cfg.pct) || 10); // 0 = sale mode: no set saving shown
    var steps = cfg.steps || [{ label: 'Step 1', short: 'top' }, { label: 'Step 2', short: 'bottom' }];
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var money = function (c) { return formatMoney(c, cfg.moneyFormat); };
    // editable wording from the section settings ({piece} {next} {pct})
    var T = cfg.text || {};
    function txt(key, fallback, vars) {
      var s = (T[key] != null && T[key] !== '') ? String(T[key]) : fallback;
      vars = vars || {};
      return s.replace(/\{(\w+)\}/g, function (m, k) { return vars[k] != null ? vars[k] : m; });
    }
    var cards = $$('[data-gbs-card]');
    // Arriving from a product page ("Make it a set" link adds ?from=<product id>): that piece goes first
    // in its step; if it's a bottom, the tops from the same line and colour go first in step 1.
    var fromCard = null, fromMatch = '';
    try {
      var fromId = new URLSearchParams(window.location.search).get('from');
      if (fromId) cards.forEach(function (c) { if (c.getAttribute('data-product-id') === fromId) fromCard = c; });
      if (fromCard && cardStep(fromCard) === 1) fromMatch = fromCard.getAttribute('data-match') || '';
    } catch (e) {}
    var store = storage();
    var picks = [null, null];
    var step = 0;
    var filters = ['', ''];
    var busy = false;
    var toastTimer = null;

    function data(card) {
      if (!card.__data) { try { card.__data = JSON.parse(card.querySelector('[data-gbs-data]').textContent); } catch (e) { card.__data = { variants: [], images: [] }; } }
      return card.__data;
    }
    function cardStep(card) { return Number(card.getAttribute('data-gbs-step')); }

    // restore
    if (store && cfg.storageKey) {
      try {
        var saved = JSON.parse(store.getItem(cfg.storageKey) || '[null,null]');
        [0, 1].forEach(function (i) {
          var p = saved[i];
          if (!p) return;
          var card = cards.filter(function (c) { return c.getAttribute('data-product-id') === p.productId && cardStep(c) === i; })[0];
          var v = card && data(card).variants.filter(function (x) { return String(x.id) === String(p.variantId) && x.available; })[0];
          if (v) picks[i] = p;
        });
      } catch (e) {}
    }
    function persist() { if (store && cfg.storageKey) { try { store.setItem(cfg.storageKey, JSON.stringify(picks)); } catch (e) {} } }

    function toast(text) {
      var t = $('[data-gbs-toast]');
      t.textContent = text; t.hidden = false;
      requestAnimationFrame(function () { t.classList.add('is-on'); });
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { t.classList.remove('is-on'); setTimeout(function () { t.hidden = true; }, 300); }, 2600);
    }

    function status(text, isError) {
      var el = $('[data-gbs-status]');
      el.hidden = !text; el.textContent = text || '';
      el.classList.toggle('is-error', !!isError);
    }

    /* ---------- steps + filters ---------- */
    function applyView() {
      var shown = 0;
      var match = step === 1 && picks[0] ? picks[0].match : '';
      cards.forEach(function (card) {
        var inStep = cardStep(card) === step;
        var f = filters[step];
        var ok = inStep && (!f || card.getAttribute('data-tags').indexOf('|' + f + '|') > -1);
        card.hidden = !ok;
        if (ok) shown++;
        var isMatch = inStep && step === 1 && match && card.getAttribute('data-match') === match;
        card.classList.toggle('is-match', !!isMatch);
        card.classList.toggle('is-from', card === fromCard);
        card.classList.toggle('is-from-match', !!(fromMatch && inStep && step === 0 && card.getAttribute('data-match') === fromMatch));
        var badge = card.querySelector('[data-gbs-match-badge]');
        if (badge) badge.hidden = !isMatch;
      });
      $$('[data-gbs-step]').forEach(function (el) { if (!el.hasAttribute('data-gbs-card')) el.hidden = Number(el.getAttribute('data-gbs-step')) !== step; });
      $$('[data-gbs-chips]').forEach(function (el) { el.hidden = Number(el.getAttribute('data-gbs-chips')) !== step; });
      $$('[data-gbs-chips="' + step + '"] [data-gbs-filter]').forEach(function (chip) {
        var on = chip.getAttribute('data-gbs-filter') === filters[step];
        chip.classList.toggle('is-active', on);
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var c = $('[data-gbs-shown]');
      if (c) c.textContent = shown + (shown === 1 ? ' piece' : ' pieces');
      $$('[data-gbs-step-btn]').forEach(function (b) {
        if (!b.classList.contains('gbs-step')) return;
        var i = Number(b.getAttribute('data-gbs-step-btn'));
        b.classList.toggle('is-active', i === step);
        b.classList.toggle('is-done', !!picks[i]);
        if (i === step) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
      });
      var line = $('[data-gbs-line]');
      if (line) line.style.width = picks[0] ? '100%' : (step === 1 ? '50%' : '0%');
    }

    function goStep(i, scroll) {
      step = i;
      applyView();
      render();
      if (scroll) {
        var target = $('.gbs-stepper');
        var top = target.getBoundingClientRect().top;
        if (top < 0 || top > window.innerHeight * 0.6) {
          var offset = parseInt(getComputedStyle(root).getPropertyValue('--gbs-sticky-top'), 10) || 24;
          window.scrollTo({ top: window.scrollY + top - offset, behavior: 'smooth' });
        }
      }
    }

    /* ---------- choosing ---------- */
    function choose(card, variant) {
      var i = cardStep(card);
      var pid = card.getAttribute('data-product-id');
      if (picks[i] && String(picks[i].variantId) === String(variant.id)) { // tap again = remove
        picks[i] = null; persist(); closeQuickView(); applyView(); render();
        return;
      }
      var d = data(card);
      picks[i] = {
        variantId: String(variant.id), productId: pid,
        title: card.getAttribute('data-title'), vendor: card.getAttribute('data-vendor'),
        match: card.getAttribute('data-match'), image: card.getAttribute('data-image'),
        size: variant.size, price: Number(variant.price) || 0, url: d.url
      };
      persist(); status('');
      closeQuickView();
      var other = i === 0 ? 1 : 0;
      if (!picks[other]) {
        goStep(other, true);
        toast(cap(txt('toastNext', '{piece} added — now choose your {next}', { piece: steps[i].short, next: steps[other].short })));
      } else {
        applyView(); render();
        toast(pct > 0 ? txt('toastDone', 'Your set is complete — {pct}% off applied', { pct: pct }) : 'Your set is complete');
      }
    }
    function cap(s) { s = String(s || ''); return s.charAt(0).toUpperCase() + s.slice(1); }

    /* ---------- quick view ---------- */
    var qv = $('[data-gbs-qv-dialog]');
    var qvCard = null, qvTrigger = null;

    function openQuickView(card, trigger) {
      if (!qv || typeof qv.showModal !== 'function') return;
      qvCard = card; qvTrigger = trigger;
      var d = data(card), i = cardStep(card);
      qv.querySelector('[data-gbs-qv-vendor]').textContent = card.getAttribute('data-vendor');
      qv.querySelector('[data-gbs-qv-title]').textContent = card.getAttribute('data-title');
      var qvPrice = qv.querySelector('[data-gbs-qv-price]');
      qvPrice.textContent = '';
      if (d.compare) { var cs = document.createElement('s'); cs.className = 'gbs-card__compare'; cs.textContent = d.compare; qvPrice.appendChild(cs); qvPrice.appendChild(document.createTextNode(' ')); }
      qvPrice.appendChild(document.createTextNode(d.price || ''));
      renderDescription(d.description || '', qv.querySelector('[data-gbs-qv-desc]'), 'gbs-qv__desc');
      var link = qv.querySelector('[data-gbs-qv-link]'); link.href = d.url || '#'; link.hidden = !d.url;
      var imgs = d.images || [];
      qv.querySelector('[data-gbs-qv-track]').innerHTML = imgs.map(function (im, k) {
        return '<img src="' + esc(im.src) + '" alt="' + esc(card.getAttribute('data-vendor') + ' ' + card.getAttribute('data-title') + ' — image ' + (k + 1)) + '" loading="' + (k ? 'lazy' : 'eager') + '">';
      }).join('');
      qv.querySelector('[data-gbs-qv-track]').scrollLeft = 0;
      qvDots(imgs.length);
      qv.querySelector('[data-gbs-qv-thumbs]').innerHTML = imgs.length > 1 ? imgs.map(function (im, k) {
        return '<button type="button" class="gbs-qv__thumb" data-gbs-qv-thumb="' + k + '" aria-label="Image ' + (k + 1) + ' of ' + imgs.length + '" aria-current="' + (k === 0) + '"><img src="' + esc(im.thumb) + '" alt=""></button>';
      }).join('') : '';
      var picked = picks[i] && picks[i].productId === card.getAttribute('data-product-id') ? String(picks[i].variantId) : '';
      var one = d.variants.length === 1;
      qv.querySelector('[data-gbs-qv-label]').textContent = one ? '' : 'Select your size';
      qv.querySelector('[data-gbs-qv-sizes]').innerHTML = d.variants.map(function (v) {
        var on = String(v.id) === picked;
        var label = one ? (on ? 'Remove from set' : 'Add to set · ' + v.size) : v.size;
        return '<button type="button" class="gbs-size' + (on ? ' is-picked' : '') + '" data-gbs-size="' + v.id + '" aria-pressed="' + on + '"' + (v.available ? '' : ' disabled') + ' aria-label="' + esc((on ? 'Remove ' : 'Add ') + card.getAttribute('data-title') + ', size ' + v.size) + '">' + esc(label) + '</button>';
      }).join('');
      qv.querySelector('[data-gbs-qv-sizes]').style.gridTemplateColumns = one ? '1fr' : '';
      qv.showModal();
      document.documentElement.classList.add('gbs-lock');
    }
    function closeQuickView() { if (qv && qv.open) qv.close(); }
    /* mobile: dots over the photo show there are more images to swipe */
    function qvDots(n) {
      var box = qv.querySelector('[data-gbs-qv-dots]');
      if (!box) {
        box = document.createElement('div');
        box.className = 'gbs-qv__dots'; box.setAttribute('data-gbs-qv-dots', '');
        qv.querySelector('[data-gbs-qv-track]').insertAdjacentElement('afterend', box);
      }
      var h = '';
      for (var k = 0; k < n; k++) h += '<button type="button" class="gbs-qv__dot" data-gbs-qv-dot="' + k + '" aria-label="Image ' + (k + 1) + ' of ' + n + '" aria-current="' + (k === 0) + '"></button>';
      box.innerHTML = n > 1 ? h : '';
    }
    if (qv) {
      qv.addEventListener('close', function () {
        document.documentElement.classList.remove('gbs-lock');
        if (qvTrigger && document.contains(qvTrigger) && !qvTrigger.closest('[hidden]')) { try { qvTrigger.focus({ preventScroll: true }); } catch (e) {} }
        qvCard = null; qvTrigger = null;
      });
      qv.addEventListener('click', function (e) { if (e.target === qv) closeQuickView(); });
      qv.querySelector('[data-gbs-qv-track]').addEventListener('scroll', function () {
        var k = Math.round(this.scrollLeft / Math.max(1, this.clientWidth));
        qv.querySelectorAll('[data-gbs-qv-thumb], [data-gbs-qv-dot]').forEach(function (b) { b.setAttribute('aria-current', String(Number(b.getAttribute('data-gbs-qv-thumb') || b.getAttribute('data-gbs-qv-dot')) === k)); });
      }, { passive: true });
    }

    /* ---------- render ---------- */
    function render() {
      var s = summarise(picks, pct);
      cards.forEach(function (card) {
        var i = cardStep(card);
        var on = !!(picks[i] && picks[i].productId === card.getAttribute('data-product-id'));
        card.classList.toggle('is-picked', on);
        var badge = card.querySelector('[data-gbs-badge]');
        if (badge) badge.hidden = !on;
        card.querySelectorAll('[data-gbs-pick]').forEach(function (btn) {
          var picked = on && String(picks[i].variantId) === btn.getAttribute('data-gbs-pick');
          btn.classList.toggle('is-picked', picked);
          btn.setAttribute('aria-pressed', picked ? 'true' : 'false');
          if (btn.classList.contains('gbs-add')) {
            if (!btn.__label) btn.__label = btn.innerHTML;
            btn.innerHTML = picked ? 'Added ✓' : btn.__label;
          }
        });
        var bar = card.querySelector('[data-gbs-reveal]');
        if (bar) {
          var sz = on ? picks[i].size : '';
          bar.classList.toggle('is-picked', on);
          bar.querySelector('[data-gbs-bar-long]').textContent = on ? 'Added · ' + sz : 'Add to set';
          bar.querySelector('[data-gbs-bar-short]').textContent = on ? '✓ ' + sz : 'Add';
        }
      });
      [0, 1].forEach(function (i) {
        var slot = $('[data-gbs-slot="' + i + '"]');
        var p = picks[i];
        slot.querySelector('.gbs-slot__empty').hidden = !!p;
        slot.querySelector('.gbs-slot__filled').hidden = !p;
        slot.classList.toggle('is-next', !p && step === i);
        if (p) {
          var img = slot.querySelector('[data-gbs-slot-img]');
          if (p.image) { img.src = p.image; img.hidden = false; } else img.hidden = true;
          slot.querySelector('[data-gbs-slot-name]').textContent = p.title;
          slot.querySelector('[data-gbs-slot-meta]').textContent = p.vendor + ' · ' + p.size + ' · ' + money(p.price);
          slot.querySelector('[data-gbs-remove]').setAttribute('aria-label', 'Remove ' + p.title);
        }
      });
      $$('[data-gbs-seg]').forEach(function (seg) { seg.classList.toggle('is-on', !!picks[Number(seg.getAttribute('data-gbs-seg'))]); });
      $('[data-gbs-count]').textContent = s.n + ' / 2';
      $('[data-gbs-sub]').textContent = money(s.sub);
      var save = $('[data-gbs-save]');
      if (save) {
        save.textContent = s.complete ? '− ' + money(s.save) + ' (' + pct + '%)' : pct + '% at 2 pieces';
        save.parentNode.classList.toggle('is-on', s.complete);
      }
      var missing = !picks[0] ? 0 : (!picks[1] ? 1 : -1);
      if (!busy) {
        $$('[data-gbs-submit]').forEach(function (b) {
          b.disabled = !s.complete;
          b.textContent = (s.complete || missing === -1) ? txt('cta', 'Add to cart') : txt('ctaPending', 'Choose your {piece}', { piece: steps[missing].short, pct: pct });
        });
      }
      // dock
      var dockThumbs = $('[data-gbs-dock-thumbs]');
      dockThumbs.innerHTML = picks.filter(Boolean).map(function (p) { return p.image ? '<img src="' + esc(p.image) + '" alt="">' : ''; }).join('');
      var last = picks[1] || picks[0];
      $('[data-gbs-dock-name]').textContent = s.n === 0 ? txt('dockEmpty', 'Choose your {piece} to start', { piece: steps[0].short, pct: pct }) : (s.complete ? picks[0].title + ' + ' + picks[1].title : last.title);
      $('[data-gbs-dock-meta]').textContent = s.n === 0 ? (pct > 0 ? txt('dockEmptyMeta', '{pct}% off when you complete the set', { pct: pct, piece: steps[0].short }) : '') : (s.complete ? (pct > 0 ? money(s.sub) + ' → ' + money(s.total) : money(s.total)) : last.vendor + ' · ' + last.size + ' · ' + money(last.price));
      $('[data-gbs-dock-count]').textContent = s.n + ' / 2';
      // dock: expandable review
      var list = $('[data-gbs-dock-list]');
      if (list) {
        list.innerHTML = [0, 1].map(function (k) {
          var p = picks[k];
          if (p) {
            return '<li class="gbs-dock__item">' + (p.image ? '<img src="' + esc(p.image) + '" alt="">' : '<span class="gbs-dock__ph"></span>') +
              '<span class="gbs-dock__itxt"><span class="gbs-dock__iname">' + esc(p.title) + '</span><span class="gbs-dock__imeta">' + esc(p.vendor + ' · ' + p.size + ' · ' + money(p.price)) + '</span></span>' +
              '<button type="button" class="gbs-slot__remove" data-gbs-remove="' + k + '" aria-label="Remove ' + esc(p.title) + '"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></li>';
          }
          return '<li class="gbs-dock__item is-empty"><button type="button" class="gbs-dock__add" data-gbs-step-btn="' + k + '"><span class="gbs-dock__ph">+</span><span class="gbs-dock__itxt"><span class="gbs-dock__iname">Add your ' + esc(steps[k].short) + '</span></span></button></li>';
        }).join('');
        $('[data-gbs-dock-totals]').innerHTML =
          '<div class="gbs-totals__row"><span>Subtotal</span><span>' + money(s.sub) + '</span></div>' +
          (s.complete && pct > 0 ? '<div class="gbs-totals__row gbs-totals__row--save is-on"><span>Set saving (' + pct + '%)</span><span>− ' + money(s.save) + '</span></div>' : '') +
          '<div class="gbs-totals__row gbs-dock__total"><span>Total</span><span>' + money(s.total) + '</span></div>';
      }
      setDock(dockOpen);
    }

    var dockOpen = false;
    function setDock(open) {
      dockOpen = !!open;
      var d = $('[data-gbs-dock]'); if (!d) return;
      d.classList.toggle('is-open', dockOpen);
      var det = $('[data-gbs-dock-details]'); if (det) det.hidden = !dockOpen;
      var sc = $('[data-gbs-dock-scrim]'); if (sc) sc.hidden = !dockOpen;
      var tg = $('[data-gbs-dock-toggle]'); if (tg) tg.setAttribute('aria-expanded', dockOpen ? 'true' : 'false');
      var lb = $('[data-gbs-dock-toggle-label]'); if (lb) lb.textContent = dockOpen ? txt('hide', 'Hide') : txt('review', 'Review');
    }

    /* ---------- add to bag ---------- */
    function submit() {
      if (busy || !summarise(picks, pct).complete) return;
      busy = true; status('');
      $$('[data-gbs-submit]').forEach(function (b) { b.disabled = true; b.classList.add('is-loading'); b.textContent = 'Adding…'; });
      var items = buildItems(picks, newBundleId(), cfg.type || 'set', cfg.bundleLabel || 'Create Your Set');
      fetch(cfg.cartAddUrl || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || 'Something went wrong. Please try again.');
          picks = [null, null]; persist();
          busy = false; $$('[data-gbs-submit]').forEach(function (b) { b.classList.remove('is-loading'); });
          goStep(0, false); status(txt('added', 'Added to your cart.'));
          if (cfg.afterAdd === 'cart') { window.location.href = cfg.cartUrl || '/cart'; return; }
          openCartDrawer(cfg, items);
        })
        .catch(function (err) {
          busy = false; $$('[data-gbs-submit]').forEach(function (b) { b.classList.remove('is-loading'); });
          render(); status(err.message, true);
        });
    }

    /* ---------- "Add to set" bar -> sizes ---------- */
    function closePick(w) {
      if (!w || !w.classList.contains('is-open')) return;
      w.classList.remove('is-open');
      var b = w.querySelector('[data-gbs-reveal]'); if (b) b.setAttribute('aria-expanded', 'false');
    }
    function closeAllPicks(except) {
      $$('[data-gbs-pickwrap].is-open').forEach(function (w) { if (w !== except) closePick(w); });
    }
    function openPick(w) {
      if (!w) return;
      closeAllPicks(w);
      w.classList.add('is-open');
      w.querySelector('[data-gbs-reveal]').setAttribute('aria-expanded', 'true');
      var first = w.querySelector('.gbs-size:not(:disabled)');
      if (first) { try { first.focus({ preventScroll: true }); } catch (e) {} }
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('[data-gbs-pickwrap]')) closeAllPicks(null);
    });
    root.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.hasAttribute && e.target.hasAttribute('data-gbs-dock-toggle')) { e.preventDefault(); setDock(!dockOpen); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (dockOpen) { setDock(false); return; }
      var w = root.querySelector('[data-gbs-pickwrap].is-open');
      if (w) { closePick(w); var b = w.querySelector('[data-gbs-reveal]'); if (b) b.focus(); }
    });

    /* ---------- events ---------- */
    root.addEventListener('click', function (e) {
      var t = e.target;
      var sz = t.closest('[data-gbs-size]');
      if (sz && qvCard) { var v = data(qvCard).variants.filter(function (x) { return String(x.id) === sz.getAttribute('data-gbs-size'); })[0]; if (v) choose(qvCard, v); return; }
      var rv = t.closest('[data-gbs-reveal]'); if (rv) { openPick(rv.closest('[data-gbs-pickwrap]')); return; }
      var pk = t.closest('[data-gbs-pick]');
      if (pk && !pk.disabled) { closePick(pk.closest('[data-gbs-pickwrap]')); var cd = pk.closest('[data-gbs-card]'); var pv = data(cd).variants.filter(function (x) { return String(x.id) === pk.getAttribute('data-gbs-pick'); })[0]; if (pv) choose(cd, pv); return; }
      var q = t.closest('[data-gbs-qv]'); if (q) { openQuickView(q.closest('[data-gbs-card]'), q); return; }
      if (t.closest('[data-gbs-qv-close]')) { closeQuickView(); return; }
      var th = t.closest('[data-gbs-qv-thumb], [data-gbs-qv-dot]');
      if (th) { var tr = qv.querySelector('[data-gbs-qv-track]'), k = Number(th.getAttribute('data-gbs-qv-thumb') || th.getAttribute('data-gbs-qv-dot')); if (tr.children[k]) tr.scrollTo({ left: tr.children[k].offsetLeft, behavior: 'smooth' }); return; }
      if (t.closest('[data-gbs-dock-toggle]') || t.closest('[data-gbs-dock-scrim]')) { setDock(!dockOpen && !t.closest('[data-gbs-dock-scrim]')); return; }
      var sb = t.closest('[data-gbs-step-btn]'); if (sb) { if (t.closest('[data-gbs-dock]')) setDock(false); goStep(Number(sb.getAttribute('data-gbs-step-btn')), true); return; }
      var rm = t.closest('[data-gbs-remove]'); if (rm) { var i = Number(rm.getAttribute('data-gbs-remove')); picks[i] = null; persist(); goStep(i, false); return; }
      var f = t.closest('[data-gbs-filter]'); if (f) { filters[step] = f.getAttribute('data-gbs-filter'); applyView(); return; }
      if (t.closest('[data-gbs-submit]')) { submit(); }
    });

    /* ---------- keep the panel clear of the theme's sticky header ---------- */
    var panel = $('[data-gbs-panel]');
    var ticking = false;
    function coveringBottom(x, y) {
      var els = document.elementsFromPoint ? document.elementsFromPoint(x, y) : [];
      for (var i = 0; i < els.length; i++) {
        if (root.contains(els[i])) continue;
        for (var n = els[i]; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
          var pos = getComputedStyle(n).position;
          if (pos === 'fixed' || pos === 'sticky') {
            var r = n.getBoundingClientRect();
            if (r.top <= y && r.bottom > y && r.height < window.innerHeight / 2) return r.bottom;
          }
        }
      }
      return 0;
    }
    function updateStickyTop() {
      ticking = false;
      var pr = panel.getBoundingClientRect();
      var x = Math.min(window.innerWidth - 2, Math.max(1, pr.left + pr.width / 2 || window.innerWidth / 2));
      var bottom = 0, y = 1;
      for (var k = 0; k < 4; k++) { var b = coveringBottom(x, y); if (b <= bottom) break; bottom = b; y = b + 1; }
      root.style.setProperty('--gbs-sticky-top', Math.round(bottom + 16) + 'px');
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(updateStickyTop); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    updateStickyTop(); setTimeout(updateStickyTop, 600);

    /* ---------- line the page up with the theme's logo (desktop) ---------- */
    function findLogo() {
      var hdr = document.querySelector('header, .header, [id*="header"], [class*="header"]');
      if (!hdr) return null;
      var tries = ['[class*="logo"] img', '[class*="logo"] svg', 'a[href="/"] img', 'a[href="/"] svg', 'a[href="/"]', '[class*="logo"]'];
      for (var i = 0; i < tries.length; i++) {
        var list = hdr.querySelectorAll(tries[i]);
        for (var j = 0; j < list.length; j++) { if (list[j].getBoundingClientRect().width > 20) return list[j]; }
      }
      return null;
    }
    function alignToLogo() {
      var logo = findLogo();
      if (!logo || window.innerWidth < 990) { root.classList.remove('is-aligned'); return; }
      var lr = logo.getBoundingClientRect(), rr = root.getBoundingClientRect();
      var gutter = Math.round(lr.left - rr.left);
      if (!lr.width || gutter < 16 || lr.left > window.innerWidth * 0.3) { root.classList.remove('is-aligned'); return; }
      root.style.setProperty('--gbs-gutter', gutter + 'px');
      root.classList.add('is-aligned');
    }
    var alignT;
    window.addEventListener('resize', function () { clearTimeout(alignT); alignT = setTimeout(alignToLogo, 120); });
    alignToLogo(); window.addEventListener('load', alignToLogo);

    // start on the first unfinished step
    step = picks[0] && !picks[1] ? 1 : 0;
    applyView();
    render();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-gbs]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* ---------- card photo swipe + dots (touch screens) ---------- */
(function () {
  var P = 'gbs', CARD = '[data-gbs-card]', DATA = '[data-gbs-data]', ROOT = '[data-gbs]';
  var mq = window.matchMedia ? window.matchMedia('(hover: none)') : null;
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function path(u) { try { return new URL(u, location.href).pathname; } catch (e) { return String(u).split('?')[0]; } }
  function sized(u, w) { return /[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=' + w) : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function build(card) {
    if (card.__gbSwipe) return; card.__gbSwipe = true;
    var media = card.querySelector('.' + P + '-card__media');
    var trig = media && media.querySelector('[data-' + P + '-qv]');
    var json = card.querySelector(DATA);
    if (!media || !trig) return;
    var dots = document.createElement('div');
    dots.className = 'gb-swipe__dots'; dots.setAttribute('aria-hidden', 'true');
    media.insertAdjacentElement('afterend', dots); // empty row keeps cards lined up
    var d = {}; try { d = JSON.parse(json.textContent); } catch (e) {}
    var first = trig.querySelector('.' + P + '-card__img:not(.' + P + '-card__img--hover)');
    // Card photo not loaded yet (lazy): use the 600w version, not the 900w src fallback (2.11.26).
    var firstSrc = first ? (first.currentSrc || sized(first.src, 600)) : '';
    var seen = {}; if (firstSrc) seen[path(firstSrc)] = 1;
    var extra = (d.images || []).filter(function (im) { var p = path(im.src); if (!im.src || seen[p]) return false; seen[p] = 1; return true; }).slice(0, 5);
    if (!extra.length) return;
    var slides = (firstSrc ? [firstSrc] : []).concat(extra.map(function (im) { return sized(im.src, 600); }));
    var track = document.createElement('div');
    track.className = 'gb-swipe';
    track.setAttribute('data-' + P + '-qv', ''); // a tap still opens quick view
    track.setAttribute('aria-hidden', 'true');
    // Speed (2.11.26): every slide is lazy, and only the first two get a src. The rest load as soon as
    // the shopper touches or swipes the photo. Before, every card fetched all 6 photos up front (~7 MB on a phone).
    track.innerHTML = slides.map(function (src, k) { return '<img ' + (k < 2 ? 'src' : 'data-src') + '="' + esc(src) + '" alt="" draggable="false" loading="lazy" decoding="async">'; }).join('');
    trig.insertAdjacentElement('afterend', track);
    function more() {
      track.removeEventListener('touchstart', more);
      track.removeEventListener('scroll', more);
      Array.prototype.forEach.call(track.querySelectorAll('img[data-src]'), function (im) { im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); });
    }
    track.addEventListener('touchstart', more, { passive: true });
    track.addEventListener('scroll', more, { passive: true });
    dots.innerHTML = slides.map(function (s, k) { return '<span' + (k ? '' : ' class="is-on"') + '></span>'; }).join('');
    card.classList.add('has-swipe');
    var cur = 0;
    track.addEventListener('scroll', function () {
      var k = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (k === cur) return; cur = k;
      Array.prototype.forEach.call(dots.children, function (s, j) { s.classList.toggle('is-on', j === k); });
    }, { passive: true });
    track.addEventListener('click', function () {
      if (!cur) return;
      var k = cur, scope = card.closest(ROOT) || document;
      setTimeout(function () { // open quick view on the photo they were looking at
        var qt = scope.querySelector('[data-' + P + '-qv-track]') || document.querySelector('[data-' + P + '-qv-track]');
        var img = qt && qt.children[k];
        if (img) { qt.scrollLeft = img.offsetLeft; qt.dispatchEvent(new Event('scroll')); }
      }, 30);
    });
  }
  function run() {
    if (mq && !mq.matches) return;
    Array.prototype.forEach.call(document.querySelectorAll(CARD), build);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
  if (mq && mq.addEventListener) mq.addEventListener('change', run);
})();